import { Box,Button } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React,{useEffect, useState} from "react";
import { useSelector,useDispatch } from "react-redux";
import CollapseSection from "../../../components/ui/CollapseSection";
import MessageForScenario from "./MessageForScenario";
import { setState,getCustomersIncludedExcludedDetails,getScenarioOtherInfoData } from "../analyzeSlice";
import DataGridScenario from './DataGridScenario';
import muiConfig from '../../../assets/MuiConfig.json'

export default function Table() {
	const dispatch=useDispatch();
	const state = useSelector((store) => store.analyze);
	const { scenarioChartDataPrepared,
			customersIncludedExcludedDataPrepared,
			selectedCountryID,
			selectedScenarioName,
			selectedScenarioID,
			showTableData,
			showCustomerIncludedExcluded,
			scenarioOtherInfoData
	 } 
		= state;

	//const { rows, columns } = scenarioChartDataPrepared;
	const { rows: initialRows, columns } = scenarioChartDataPrepared;
	const { rows1=[], columns1=[] } = customersIncludedExcludedDataPrepared || {};

	const [rows, setRows] = useState(initialRows);
	const [selectedCompareCount,setSelectedCompareCount]=useState(0);

		useEffect(()=>{
			if(scenarioChartDataPrepared?.rows){
				setRows(scenarioChartDataPrepared.rows);
				setSelectedCompareCount(0);
			}
		},[scenarioChartDataPrepared]);


	  const handleCompareChange = (event, row) => {
		dispatch(setState("showCustomerIncludedExcluded",false));
		const isChecked = event.target.checked;

		const updatedRows = rows.map((r) =>
		  r.id === row.id ? { ...r, compare: isChecked } : r
		);
	
		setRows(updatedRows); 

		setSelectedCompareCount((prevCount)=> isChecked ? prevCount + 1 : prevCount - 1);
		
		if(isChecked && selectedCompareCount>=2){
			showMessage("Please select only 2 record to compare","info");
		}
	  };

		const updatedColumns = columns.map((column) => {
			if (column.field === "compare") {
			return {
				...column,
				renderCell: (params) => (
				<input
					type="checkbox"
					onChange={(event) => handleCompareChange(event, params.row)}
					checked={params.row.compare || false} 
					style={{
						alignContent: "center",
						width: "20px",
						height: "20px",
						backgroundColor: params.row.compare ? "#AD2A1C" : "transparent",
						borderColor: params.row.compare ? "#AD2A1C" : "#ccc",
						cursor: "pointer",
						accentColor: params.row.compare ? "#AD2A1C" : "initial",
					  }}
				/>
				),
			};
			}
			return column;
		});

		const handleCompareClick = () => {
			debugger;
			const selectedRows = rows.filter((row) => row.compare);
			//console.log("Comparing rows: ", selectedRows); 
			//  const obj = {
			//  	scenario1: selectedRows[0].id,
			//  	scenario2: selectedRows[1].id,
			//  };

			let scenario1, scenario2;

			if (selectedRows[0].hierarchy === "parent") {
			  scenario1 = selectedRows[0].id;
			  scenario2 = selectedRows[1].id;
			} else if (selectedRows[1].hierarchy === "parent") {
			  scenario1 = selectedRows[1].id;
			  scenario2 = selectedRows[0].id;
			} else {
			  // Assuming hierarchy values can be compared lexicographically
			  if (selectedRows[0].hierarchy < selectedRows[1].hierarchy) {
				scenario1 = selectedRows[0].id;
				scenario2 = selectedRows[1].id;
			  } else {
				scenario1 = selectedRows[1].id;
				scenario2 = selectedRows[0].id;
			  }
			}
			
			const obj = {
			  scenario1: scenario1,
			  scenario2: scenario2
			};			



			dispatch(setState("selectedScenarios",[selectedRows[0].id,selectedRows[1].id]));
			dispatch(getCustomersIncludedExcludedDetails(obj));
			dispatch(setState("showCustomerIncludedExcluded",true));
			const obj1 = {
				//scenarioName: selectedScenarioName,
				scenarioId: selectedScenarioID,
				countryID: selectedCountryID,
			};
			dispatch(getScenarioOtherInfoData(obj1));

		};

		const showMessage = (message, severity) => {
			dispatch(setState("message", message));
			dispatch(setState("severity", severity));
			dispatch(setState("messageOpen", true));
		};

	return (
		//checkboxSelection
		<Box sx={{ mt: 3 }}>
			{showTableData && (
			<>
			<Box>
				<MessageForScenario/>
			</Box>
			<CollapseSection title="Scenario Progression Details">
			<DataGridPro
			sx={{mt:2}}
			disableColumnMenu
			disableRowSelectionOnClick
			rows={rows} 
			columns={updatedColumns}
			initialState={{
				pagination: { paginationModel: { pageSize:20, page:0 }}
			}}
			pagination
			pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}
			/>
			</CollapseSection>

			   {selectedCompareCount === 2 && (
				<Box sx={{ mt: 2, textAlign: "right" }}>
				<Button variant="contained" color="primary" onClick={handleCompareClick}
				sx={{
					bgcolor: "darkred.light",
					color: "white.main",
					textTransform: "none",
					fontWeight: "bold",
					"&:hover": {
						bgcolor: "darkred.main",
						color: "white.main",
					},
						}}  >
					Compare
				</Button>
				</Box>
      )}
	  	
		{(showCustomerIncludedExcluded && rows1.length>0 && columns1.length>0) &&
		(<><CollapseSection title="Customer/Customer Group Included /Excluded">
			<Box sx={{ display: "flex", alignItems: "center", mb: 2 ,mt:2,ml:2 }}>
				<Box
					sx={{
					width: 20,
					height: 20,
					backgroundColor: "#FF2929",
					//border:"1px solid black",
					mr: 1,
					}}
				></Box>
      			<Box sx={{ mr: 3,fontWeight:"bold" }}>Customer Removed</Box>
				<Box
					sx={{
					width: 20,
					height: 20,
					backgroundColor: "#197E37",
					//border:"1px solid black",
					mr: 1,
					ml:4,
					}}
				></Box>
     			 <Box sx={{fontWeight:"bold"}}>Customer Added</Box>
    		</Box>
		<DataGridPro 
			sx={{mt:2}}
			disableColumnMenu
			disableRowSelectionOnClick
			rows={rows1} 
			columns={columns1}
			initialState={{
				pagination: { paginationModel: { pageSize:20, page:0 }}
			  }}
			pagination
			pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}
			getRowClassName={(params) => {
				if (params.row.difference === "added") {
				return "row-added";
				} else if (params.row.difference === "Removed") {
				return "row-removed";
				}
				return "";
			}}
		/> 
			
		</CollapseSection>
		{scenarioOtherInfoData!==null && (
			<CollapseSection title="Other Information">
			<DataGridScenario/>
			</CollapseSection>
		)}
		</>		
	)
      }
	  		</>
			)}
		</Box>
	);
}
